import { render, staticRenderFns } from "./loanCalculation.vue?vue&type=template&id=dbdb7f1a&scoped=true&lang=html"
import script from "./loanCalculation.vue?vue&type=script&lang=js"
export * from "./loanCalculation.vue?vue&type=script&lang=js"
import style0 from "./loanCalculation.vue?vue&type=style&index=0&id=dbdb7f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb7f1a",
  null
  
)

export default component.exports